export default {
  bookings: state => state.bookings,
  bookingProfiles: state => state.bookingProfiles,
  selectedBookingProfileId: state => state.selectedBookingProfileId,
  selectedBooking: state => state.selectedBooking,
  selectedBookingProfile: state => {
    if (!state.selectedBookingProfile) {
      if (state.bookingProfiles.length > 0) {
        return state.bookingProfiles.find(
          place => place.BookingProfileID === state.selectedBookingProfileId
        )
      }
    }
    return state.selectedBookingProfile
  },
  currentPageNumber: state => state.currentPageNumber,
  pageSize: state => state.pageSize,
  nextAvailablePage: state => state.nextAvailablePage
}
